import { Button } from '@cibli/shared';
import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface JobListErrorStateProps {
  error: string;
  onRetry: () => void;
}

export default function JobListErrorState({ error, onRetry }: JobListErrorStateProps) {
  const { t } = useTranslation();

  return (
    <div className="text-center py-16">
      <div className="w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center mx-auto mb-4">
        <AlertCircle className="w-8 h-8 text-destructive" />
      </div>
      <h3 className="text-lg font-medium text-foreground mb-2">
        {t('dashboard.jobs.error.title')}
      </h3>
      <p className="text-muted-foreground mb-6">{error}</p>
      <Button onClick={onRetry}>{t('dashboard.jobs.error.retry')}</Button>
    </div>
  );
}
